
import { Injectable } from "@angular/core";
import { NetworkService } from "../../common/network.service";

@Injectable()
export class PlanService {
  constructor(private _networkService: NetworkService) { }

  getplanList() {
    return this._networkService.get("api/courseplan", null, null, "bearer");
  }
  getplanListById(query) {
    return this._networkService.get("api/courseplan?" + query, null, null, "bearer");
  }
  saveplan(body: any) {
    return this._networkService.post("api/courseplan", body, null, "bearer");
  }
  Editplan(body: any) {
    return this._networkService.put("api/courseplan", body, null, "bearer");
  }

  

  deleteplan(id: any) {
    return this._networkService.delete("api/courseplan/" + id, null, "bearer")
  }
  getReportingList() {
    return this._networkService.get("api/reporter", null, null, "bearer");
  }
  saveReport(body: any) {
    return this._networkService.post("api/reporter", body, null, "bearer");
  }
  editReport(body: any) {
    return this._networkService.put("api/reporter", body, null, "bearer");
  }
  deletereport(id: any) {
    return this._networkService.delete("api/reporter/" + id, null, "bearer")
  }
}
